/** Which social app's in-app browser we are running in (2026-09-17). Every Meta ad visitor sits in one,
 * and Google refuses its sign-in inside embedded browsers, so the auth pages adapt (InAppBrowserNotice)
 * and the claim surfaces put the app first (preferApp). Pure — Jest in inAppBrowser.test.ts. */
export type InAppBrowser = 'facebook' | 'instagram' | 'messenger' | null;

export function detectInAppBrowser(ua: string | null | undefined): InAppBrowser {
  const s = ua || '';
  if (/Instagram/i.test(s)) return 'instagram';
  if (/FB_IAB|FBAN|FBAV|FB4A|FBIOS/i.test(s)) return /Messenger|FB_IAB\/Orca|Orca-Android/i.test(s) ? 'messenger' : 'facebook';
  return null;
}

export function inAppBrowser(): InAppBrowser {
  try { return detectInAppBrowser(typeof navigator !== 'undefined' ? navigator.userAgent : ''); } catch { return null; }
}

export const IN_APP_BROWSER_NAMES: Record<Exclude<InAppBrowser, null>, string> = {
  facebook: 'Facebook', instagram: 'Instagram', messenger: 'Messenger',
};
